import React from 'react'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useTranslation } from 'react-i18next'

export default ({ onChange, round, tender }) => {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2">
      <Label className="text-sm whitespace-nowrap">{t('Procurement_tenders_round_label', 'Round')}:</Label>
      <Select
        value={String(round || tender.round)}
        onValueChange={(val) => onChange({ target: { value: val } })}
      >
        <SelectTrigger className="flex-1">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {Array.from(Array(tender.round)).map((_, i) => (
            <SelectItem key={i} value={String(i + 1)}>
              {i + 1}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
